import React from "react";
import { fmtDateDMY } from "../utils";
import type { ReportPrefs } from "../../../../../hooks/useReportPreferences";

interface Props {
  businessName: string;
  accountName: string;
  from: string;
  to: string;
  prefs?: ReportPrefs;
}

export default function QuickReportHeader({ businessName, accountName, from, to, prefs }: Props) {
  const showName = prefs?.showCompanyName ?? true;
  const showTitle = prefs?.showReportTitle ?? true;
  const showPeriod = prefs?.showReportPeriod ?? true;
  const alignment = prefs?.headerAlignment ?? "center";
  const nameFirst = (prefs?.headerLayout ?? "name-first") === "name-first";
  const alignClass = alignment === "left" ? "text-left" : alignment === "right" ? "text-right" : "text-center";
  const nameBlock = showName ? <div className="text-[15px] font-bold text-ink">{businessName}</div> : null;
  const titleBlock = showTitle ? <div className="text-xl font-bold text-ink mt-0.5">Account quick report</div> : null;

  return (
    <div className={`${alignClass} py-4 border-b border-[#EEF1F4]`}>
      {nameFirst ? nameBlock : titleBlock}
      {nameFirst ? titleBlock : nameBlock}
      {showPeriod && (
        <div className="text-xs text-ink3 mt-1">
          {accountName} &middot; {fmtDateDMY(from)} to {fmtDateDMY(to)}
        </div>
      )}
    </div>
  );
}